import React from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { styled, Drawer as MuiDrawer, useMediaQuery } from '@mui/material';

import Icon from '../icons/Icon';
import { ICONS } from '../icons';
import { toggleSidebar } from '../redux/sidebar/sidebarReducer';
import HeaderColumn from '../header/components/header-column/HeaderColumn';
import MobileMenu from './components/mobile-menu/MobileMenu';
import AllProjectButton from '../header/components/projects/AllProjectButton';
import BurgerMenuIcon from './components/burger-menu-icon/BurgerMenuIcon';
import ActionsWrapper from './components/actions-wrapper/ActionsWrapper';
import MultipleRoute from '../components/multiple-route/MultipleRoute';
import { APP_HEADER_ACTION_ROUTES, APP_HEADER_PRIMARY_ROUTES } from '../header/appHeaderRoutes';

import scss from './HeaderMobile.module.scss';

function HeaderMobile() {
  const isTablet = useMediaQuery('(max-width: 1024px)');

  const dispatch = useDispatch();

  const slimSidebar = useSelector((state) => state.sidebar.slim);

  const handleToggleMenu = () => {
    dispatch(toggleSidebar());
  };

  if (!isTablet) {
    return null;
  }

  return (
    <div className={scss.wrapper}>
      <header className={scss.header}>
        <Link to='/projects'>
          <Icon icon={ICONS.Logo} className={scss.logo} />
        </Link>

        <HeaderColumn>
          <MultipleRoute paths={['/projects/create/*', '/projects/edit/*']} element={<AllProjectButton />} />
          <Routes>
            {APP_HEADER_ACTION_ROUTES.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>

          <BurgerMenuIcon />
        </HeaderColumn>
      </header>

      <Drawer open={!slimSidebar} hidden={slimSidebar} anchor='right' onClose={handleToggleMenu} variant='temporary'>
        <MobileMenu />
      </Drawer>

      <Routes>
        {APP_HEADER_PRIMARY_ROUTES.map(({ path, element, mobileActionsWrapper }) => (
          <Route
            key={path}
            path={path}
            element={mobileActionsWrapper ? <ActionsWrapper>{element}</ActionsWrapper> : element}
          />
        ))}
      </Routes>
    </div>
  );
}

export default HeaderMobile;

const Drawer = styled(MuiDrawer)({
  '& .MuiDrawer-paper': {
    background: 'var(--sidebar-bg)',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
  },
  '& .MuiBackdrop-root': {
    opacity: '0 !important',
  },
});
